// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"937eca32","703":"9bc1e628","787":"ba903116"}[chunkId] + ".chunk.js";
};